import {Component, OnInit, ElementRef, ViewChild, AfterViewInit} from '@angular/core';
import {routerTransition} from '../../router.animations';
import {DashboardProvider} from './dashboard-provider';
import {SiUtil} from '../../utility/SiUtil';
import {Router} from '@angular/router';
import {single} from './data';
import {LazyLoadRequest} from '../../request/LazyLoadRequest';
import {InvoiceListDataSource} from '../admin/invoice-list/invoiceListDataSource.ts';
import {Injector} from '@angular/core';
import {AuthService} from '../../utility/auth-service';
import {Chart} from 'chart.js';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    animations: [routerTransition()]
})
export class DashboardComponent implements OnInit, AfterViewInit {
    totalPurGst: any;
    totalGst: any;
    selectedYear: any[];
    @ViewChild('myBarChart') myBarChart!: ElementRef<HTMLCanvasElement>;
    chart: any;
    @ViewChild('myPieChart') myPieChart!: ElementRef<HTMLCanvasElement>;
    piechart!: Chart;
    //    
    //     saleData = [
    //        {name: "Sales", value: 15000},
    //        {name: "Expenses", value: 150000},
    //        {name: "Difference", value: -20000},
    //    ];
    selectedDateRange: string = '1W';
    selectedDateRangePie: string = '1W';
    invoiceTotal: any;
    bankAmt: any;
    bank: any;
    cashAmt: any;
    payableOverdues: number;
    payableTotal: any;
    purchaseCount: any;
    totalPaid: number;
    paidRecords: any[] = [];
    dataLists: any[] = [];
    dataListsPie: any[] = [];
    financialYear: any[] = [];
    labelList: any[] = [];
    labelListPie: any[] = [];
    totalOverdues: number;
    overDueRecords: any[] = [];
    totalSales: number;
    counts: {};
    datePipe: any;
    projects: any[];
    lazyCriteria: any;
    public alerts: Array<any> = [];
    public sliders: Array<any> = [];
    single: any[];
    view: any[] = [800, 600];

    // options
    showLegend: boolean = true;
    showLabels: boolean = true;

    colorScheme = {
        domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
    };

    constructor(private provider: DashboardProvider, private util: SiUtil, public router: Router,
        public dataSource: InvoiceListDataSource, public injector: Injector, public auth: AuthService,

    ) {
        Object.assign(this, {single});
        this.getProjectList();
        this.sliders.push(
            {
                imagePath: 'assets/images/slider1.jpg',
                label: 'First slide label',
                text:
                    'EntryLogs'
            },
            {
                imagePath: 'assets/images/slider2.jpg',
                label: 'Second slide label',
                text: 'EntryLogs'
            },
            {
                imagePath: 'assets/images/slider3.jpg',
                label: 'Third slide label',
                text:
                    'EntryLogs'
            }
        );

        this.alerts.push(
            {
                id: 1,
                type: 'success',
                message: `Alert`
            },
            {
                id: 2,
                type: 'warning',
                message: `Warning`
            }
        );
    }

    async ngOnInit() {
        await this.getFinancialYear();
        //        this.getProjectList();
        this.getInvoicesLst();
        //        this.getPurchaseList();
        this.getRecivableTotalAmount();
        this.getOverDueTotalAmount();
        this.getPurchaseTotalAmount();
        this.getBankTotalAmount();
        this.getCashTotalAmount();
        this.getInvoiceTotalAmount();
        this.selectDateRange("1W");
        this.selectDateRangePie("1W");
        this.pieChartMethod();
        

    }
    
    estimate() {
        this.router.navigate(['/admin/estimate']);
    }
    jms() {
        this.router.navigate(['/admin/mom']);
    }
    invoice() {
        this.router.navigate(['/admin/invoices']);
    }
    product() {
        this.router.navigate(['/admin/products']);
    }
    purchase() {
        this.router.navigate(['/admin/purchase-list']);
    }
    getFinancialYear() {
        return new Promise(async (resolve, reject) => {
            this.lazyCriteria = new LazyLoadRequest();
            this.provider.doHttpPost("/api/invoice/getFinYear", this.lazyCriteria, true).subscribe((data: any) => {
                console.log(data);
                this.financialYear = data;
                const activeYear = this.financialYear.find((item) => item.active === true);
                if (activeYear) {
                    this.selectedYear = activeYear.finYear;
                }
                resolve(data);
            })
        })
    }
    onYearSelectionChange() {
        console.log('Selected year changed:', this.selectedYear);
        // Add your logic here to handle the change
        this.getRecivableTotalAmount();
        this.getOverDueTotalAmount();
        this.getPurchaseTotalAmount();
        this.getBankTotalAmount();
        this.getCashTotalAmount();
        this.getInvoiceTotalAmount();
        this.selectDateRange("1W");
        this.selectDateRangePie("1W");
        this.pieChartMethod();
    }
    ngAfterViewInit() {
        if (this.chart) {
            this.chart.destroy();
        }

        this.chart = new Chart(this.myBarChart.nativeElement, {
            type: 'bar',
            data: {
                labels: this.labelList,
                datasets: [
                    {
                        label: 'Revenue',
                        backgroundColor: 'rgba(2,117,216,1)',
                        borderColor: 'rgba(2,117,216,1)',
                        data: this.dataLists,
                    },
                ],
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            time: {
                                unit: 'month',
                            },
                            gridLines: {
                                display: false,
                            },
                            ticks: {
                                maxTicksLimit: 7,
                            },
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                min: 0,
                                max: 250000,
                                maxTicksLimit: 5,
                            },
                            gridLines: {
                                display: true,
                            },
                        },
                    ],
                },
                legend: {
                    display: false,
                },
                
            },
        });







        }

//    pieChartMethod    (){
//              
//         this.piechart = new Chart(this.myPieChart.nativeElement    , {
//               type: 'pi    e',
//            data    : {
//                labels: this.labelListP    ie,
//                datasets    : [
//                        {
//                        data: this.dataListsP    ie,
//                        backgroundColor: ['#007bff', '#dc3545', '#ffc107', '#28a745','#007bff', '#dc3545', '#ffc107', '#28a745','#007bff', '#dc3545', '#ffc107', '#28a745    '],
//                        },
//                    ],
//                },
//            });
//            
//    }

    pieChartMethod() {
        if (this.piechart) {
            this.piechart.destroy();
        }
        const canvas: HTMLCanvasElement = this.myPieChart.nativeElement;
        const context = canvas.getContext('2d');

        // Set canvas size explicitly
        canvas.width = canvas.parentElement.clientWidth; // Set width to match parent width
        canvas.height = canvas.parentElement.clientHeight; // Set height to match parent height


        this.piechart = new Chart(this.myPieChart.nativeElement, {
            type: 'pie',
            data: {
                labels: this.labelListPie,
                datasets: [
                    {
                        data: this.dataListsPie,
                        backgroundColor: ['#007bff', '#dc3545', '#ffc107', '#28a745', '#007bff', '#dc3545', '#ffc107', '#28a745', '#007bff', '#dc3545', '#ffc107', '#28a745'],
                    },
                ],
            },
            options: {
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var label = data.labels[tooltipItem.index];
                            var value = dataset.data[tooltipItem.index];
                            return label + ': ' + value;
                        },
                    },
                },
            },
        });
    }
                     


    selectDateRange(dateRange: string): void {
        console.log("Selected date range:", dateRange);
        this.selectedDateRange = dateRange;
        if (dateRange == '1W') {
            console.log("1w");


            let result: any = {};

            let curr = new Date(); // get current date
            console.log(curr);

            // Calculate the first day of the week (Monday)
            let first = curr.getDate() - curr.getDay() + (curr.getDay() === 0 ? -6 : 1);
            console.log(first);

            console.log(curr.getDate());
            console.log(curr.getDay());
            let last = first + 6; // last day is the first day + 6
            console.log(last);
            result = {
                oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(new Date(curr.setDate(first)).toUTCString()),
                type: "WEEK",
                finYear: this.selectedYear
                //                 lastDay: new Date(curr.setDate(last)).toUTCString()
            };
            console.log(result.firstDay);
            //             return result;

            this.provider.doHttpPost("/api/invoice/getGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataLists = data.dataLists;
                    this.labelList = data.labelList;
                    this.ngAfterViewInit();

                }
            })


        }
        if (dateRange == '1M') {
            console.log('1M');


            let result: any = {};

            let curr = new Date(); // get current date
            let firstDay = new Date(curr.getFullYear(), curr.getMonth(), 1); // First day of the current month
            let lastDay = new Date(curr.getFullYear(), curr.getMonth() + 1, 0); // Last day of the current month

            result = {
                oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(firstDay),
                type: "ONEMONTH",
                finYear: this.selectedYear
                //                 lastDay: lastDay,
            };
           
//             return result;

            this.provider.doHttpPost("/api/invoice/getGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataLists = data.dataLists;
                    this.labelList = data.labelList;
                    this.ngAfterViewInit();


                }
            })

        }
        if (dateRange == '3M') {
            console.log("3M");


            let result: any = {};

            let curr = new Date(); // get current date
            let firstDay = new Date(curr.getFullYear(), curr.getMonth() - 2, 1); // First day of the current month
            let lastDay = new Date(curr.getFullYear(), curr.getMonth() + 1, 0); // Last day of the current month

            result = {
                 oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(firstDay),
                type: "THREEMONTH",
                finYear: this.selectedYear
                //                 lastDay: lastDay,
            };
            console.log(result.firstDay);
            console.log(result.lastDay);
            //             return result;
            this.provider.doHttpPost("/api/invoice/getGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataLists = data.dataLists;
                    this.labelList = data.labelList;
                    this.ngAfterViewInit();
                }
            })



        }
        if (dateRange == '6M') {
            console.log("6M");


            let result: any = {};

            let curr = new Date(); // get current date
            let firstDay = new Date(curr.getFullYear(), curr.getMonth() - 5, 1); // First day of the current month
            let lastDay = new Date(curr.getFullYear(), curr.getMonth() + 1, 0); // Last day of the current month

            result = {
                 oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(firstDay),
                type: "SIXMONTH",
                finYear: this.selectedYear
                //                 lastDay: lastDay,
            };
            console.log(result.firstDay);
            console.log(result.lastDay);
            //             return result;

            this.provider.doHttpPost("/api/invoice/getGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataLists = data.dataLists;
                    this.labelList = data.labelList;
                    this.ngAfterViewInit();
                }
            })


        }
        if (dateRange == '1Y') {
            console.log("1Y");
            let result: any = {};

            let curr = new Date(); // get current date
            console.log(curr);
            let firstDay = new Date(curr.getFullYear(), 0, 1); // First day of the current year
            console.log(firstDay);
            let lastDay = new Date(curr.getFullYear(), 11, 31); // Last day of the current year
            console.log(lastDay);
            result = {
                 oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(firstDay),
                type: "ONEYEAR",
                finYear: this.selectedYear
                //                 lastDay: lastDay,
            };
            console.log(result.firstDay);
            console.log(result.lastDay);
            //             return result;
            this.provider.doHttpPost("/api/invoice/getGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataLists = data.dataLists;
                    this.labelList = data.labelList;
                    this.ngAfterViewInit();
                }
            })
        }

    }

    selectDateRangePie(dateRange: string): void {
        console.log("Selected date range:", dateRange);
        this.selectedDateRangePie = dateRange;
        if (dateRange == '1W') {
            console.log("1w");


            let result: any = {};

            let curr = new Date(); // get current date
            console.log(curr);

            // Calculate the first day of the week (Monday)
            let first = curr.getDate() - curr.getDay() + (curr.getDay() === 0 ? -6 : 1);
            console.log(first);

            console.log(curr.getDate());
            console.log(curr.getDay());
            let last = first + 6; // last day is the first day + 6
            console.log(last);
            result = {
                 oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(new Date(curr.setDate(first)).toUTCString()),
                type: "WEEK",
                finYear: this.selectedYear
                //                 lastDay: new Date(curr.setDate(last)).toUTCString()
            };
            console.log(result.firstDay);
            //             return result;

            this.provider.doHttpPost("/api/purchase/getPurchaseGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataListsPie = data.dataLists;
                    console.log(this.dataListsPie);
                    this.labelListPie = data.labelList;
                    console.log(this.labelListPie);
                    this.pieChartMethod();

                }
            })


        }
        if (dateRange == '1M') {
            console.log('1M');


            let result: any = {};

            let curr = new Date(); // get current date
            let firstDay = new Date(curr.getFullYear(), curr.getMonth(), 1); // First day of the current month
            let lastDay = new Date(curr.getFullYear(), curr.getMonth() + 1, 0); // Last day of the current month

            result = {
                 oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(firstDay),
                type: "ONEMONTH",
                finYear: this.selectedYear
                //                 lastDay: lastDay,
            };
           
//             return result;

            this.provider.doHttpPost("/api/purchase/getPurchaseGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataListsPie = data.dataLists;
                    this.labelListPie = data.labelList;
                    this.pieChartMethod();


                }
            })

        }
        if (dateRange == '3M') {
            console.log("3M");


            let result: any = {};

            let curr = new Date(); // get current date
            let firstDay = new Date(curr.getFullYear(), curr.getMonth() - 2, 1); // First day of the current month
            let lastDay = new Date(curr.getFullYear(), curr.getMonth() + 1, 0); // Last day of the current month

            result = {    
                 oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(firstDay),
                type: "THREEMONTH",
                finYear: this.selectedYear
                //                 lastDay: lastDay,
            };
            console.log(result.firstDay);
            console.log(result.lastDay);
            //             return result;
            this.provider.doHttpPost("/api/purchase/getPurchaseGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataListsPie = data.dataLists;
                    this.labelListPie = data.labelList;
                    this.pieChartMethod();
                }
            })



        }
        if (dateRange == '6M') {
            console.log("6M");


            let result: any = {};

            let curr = new Date(); // get current date
            let firstDay = new Date(curr.getFullYear(), curr.getMonth() - 5, 1); // First day of the current month
            let lastDay = new Date(curr.getFullYear(), curr.getMonth() + 1, 0); // Last day of the current month

            result = {
                 oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(firstDay),
                type: "SIXMONTH",
                finYear: this.selectedYear
                //                 lastDay: lastDay,
            };
            console.log(result.firstDay);
            console.log(result.lastDay);
            //             return result;

            this.provider.doHttpPost("/api/purchase/getPurchaseGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataListsPie = data.dataLists;
                    this.labelListPie = data.labelList;
                    this.pieChartMethod();
                }
            })


        }
        if (dateRange == '1Y') {
            console.log("1Y");
            let result: any = {};

            let curr = new Date(); // get current date
            console.log(curr);
            let firstDay = new Date(curr.getFullYear(), 0, 1); // First day of the current year
            console.log(firstDay);
            let lastDay = new Date(curr.getFullYear(), 11, 31); // Last day of the current year
            console.log(lastDay);
            result = {
                 oprId: this.provider.getSession().OPR_ID,
                firstDay: this.util.dateTransform_yyyyMMdd(firstDay),
                type: "ONEYEAR",
                finYear: this.selectedYear
                //                 lastDay: lastDay,
            };
            console.log(result.firstDay);
            console.log(result.lastDay);
            //             return result;
            this.provider.doHttpPost("/api/purchase/getPurchaseGraphData", result, true).subscribe((data: any) => {
                console.log(data);
                if (data) {
                    this.dataListsPie = data.dataLists;
                    this.labelListPie = data.labelList;
                    this.pieChartMethod();
                }
            })
        }

    }


    public closeAlert(alert: any) {
        const index: number = this.alerts.indexOf(alert);
        this.alerts.splice(index, 1);
    }

    getProjectList() {
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.pageSize = 100;
        this.lazyCriteria.paramObj = {
            orgId: this.provider.authService.getSession().ORG_ID,
            oprId: this.provider.authService.getSession().OPR_ID
        }
        this.provider.doHttpPostLazy("/api/project/getList", true, this.lazyCriteria).subscribe((list: any[]) => {
            console.log(list);
            this.projects = list;
            console.log(this.projects);
            for (let i = 0; i < this.projects.length; i++) {
                console.log(this.projects[i].sales);
                let value1 = this.projects[i].orderValue;
                let value2 = this.projects[i].sales;
                console.log(value2);
                let value: number = (value2 / value1) * 100;
                console.log(Math.trunc(value));
                this.projects[i].percent = Math.trunc(value);
            }
        })
    }
    getPurchaseList() {
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.paramObj = {
            orgId: this.provider.authService.getSession().ORG_ID,
            oprId: this.provider.authService.getSession().OPR_ID,
            crBy: this.auth.getSession().uid
        }
        this.provider.doHttpPostLazy("/api/purchase/getPurchaseList", true, this.lazyCriteria).subscribe((list: any[]) => {
            console.log(list);
            if (list != null) {

                this.purchaseCount = list.length;
                console.log(list);
                this.payableTotal = 0;
                this.payableOverdues = 0;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].recordpaymentStatus) {
                        let A: number = list[i].paidAmt;
                        this.payableTotal += A;
                    }
                    if (list[i].overDue) {
                        let A: number = list[i].paidAmt;
                        this.payableOverdues += A;
                    }
                }
            }

        })
    }
    getRecivableTotalAmount() {
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.pageSize = 50;
        this.lazyCriteria.paramObj = {
            orgId: this.provider.authService.getSession().ORG_ID,
            oprId: this.provider.authService.getSession().OPR_ID,
            finYear: this.selectedYear
        }
        console.log(this.lazyCriteria);
        this.provider.doHttpPost("/api/invoice/getTotalRecivable", this.lazyCriteria, true).subscribe((data: any) => {
            console.log(data);
            this.totalSales = data.totalRecAmount;
            this.totalGst = "Total Gst "+data.totalGst.toFixed(2);
        })
    }

    getOverDueTotalAmount() {
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.pageSize = 50;
        this.lazyCriteria.paramObj = {
            orgId: this.provider.authService.getSession().ORG_ID,
            oprId: this.provider.authService.getSession().OPR_ID,
            status:"OverDraft",
            finYear: this.selectedYear
        }
        this.provider.doHttpPost("/api/invoice/getTotalOverDueAmount", this.lazyCriteria, true).subscribe((data: any) => {
            console.log(data);
            this.totalOverdues = data.totalOverDueAmount;
        })
    }
    getPurchaseTotalAmount() {
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.pageSize = 50;
        this.lazyCriteria.paramObj = {
            orgId: this.provider.authService.getSession().ORG_ID,
            oprId: this.provider.authService.getSession().OPR_ID,
            finYear: this.selectedYear
        }
        this.provider.doHttpPost("/api/purchase/getTotalPayable", this.lazyCriteria, true).subscribe((data: any) => {
            console.log(data);
            this.payableTotal = data.totalPurAmt;
            this.totalPurGst ="Total Gst "+data.totalPurGst.toFixed(2);
        })
    }
    getBankTotalAmount() {
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.pageSize = 50;
        this.lazyCriteria.paramObj = {
            orgId: this.provider.authService.getSession().ORG_ID,
            oprId: this.provider.authService.getSession().OPR_ID,
            paymentMode:"BANK",
            finYear: this.selectedYear
        }
        this.provider.doHttpPost("/api/recordPayment/bankAmt", this.lazyCriteria, true).subscribe((data: any) => {
            console.log(data);
            this.bankAmt = data.bankAmt;
        })
    }
    getCashTotalAmount() {
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.pageSize = 50;
        this.lazyCriteria.paramObj = {
            orgId: this.provider.authService.getSession().ORG_ID,
            oprId: this.provider.authService.getSession().OPR_ID,
             paymentMode:"CASH",
             finYear: this.selectedYear

        }
        this.provider.doHttpPost("/api/recordPayment/bankAmt", this.lazyCriteria, true).subscribe((data: any) => {
            console.log(data);
            this.cashAmt = data.bankAmt;
        })
    }
    getInvoiceTotalAmount() {
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.pageSize = 50;
        this.lazyCriteria.paramObj = {
            orgId: this.provider.authService.getSession().ORG_ID,
            oprId: this.provider.authService.getSession().OPR_ID,
            finYear: this.selectedYear

        }
        this.provider.doHttpPost("/api/invoice/getTotalPaidAmount", this.lazyCriteria, true).subscribe((data: any) => {
            console.log(data);
            this.invoiceTotal = data.totalPaidAmount;
        })
    }

    async getInvoicesLst() {
        this.dataSource = new InvoiceListDataSource(this.injector, this.provider.http, this.provider.authService);   /// init datasource 
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.pageSize = 100;
        this.lazyCriteria.paramObj = {

            orgId: this.provider.authService.getSession().ORG_ID,
            oprId: this.provider.authService.getSession().OPR_ID,
            voidInvoice: false,
        }
        this.lazyCriteria.sortFiled = "invoice";
        this.lazyCriteria.sortValue = "desc";
        //        this.lazyCriteria.sortFiled = "name";
        this.dataSource.loadLazyLst(this.lazyCriteria);
        this.counts = await this.dataSource.loadCount(this.lazyCriteria);

        console.log(this.dataSource.oprsSubject.value);
        this.totalSales = 0;
        for (let i = 0; i < this.dataSource.oprsSubject.value.length; i++) {
            let A: number = this.dataSource.oprsSubject.value[i].invcFinalTotal;
            console.log(A);
            this.totalSales += A;
            console.log(this.totalSales);
            console.log(this.dataSource.oprsSubject.value[i].overDue);
            if (this.dataSource.oprsSubject.value[i].overDue == true && this.dataSource.oprsSubject.value[i].recordpaymentStatus == false) {
                this.overDueRecords.push(this.dataSource.oprsSubject.value[i]);
            }
            if (this.dataSource.oprsSubject.value[i].recordpaymentStatus) {
                this.paidRecords.push(this.dataSource.oprsSubject.value[i]);
            }
        }
        this.totalOverdues = 0;
        for (let j = 0; j < this.overDueRecords.length; j++) {
            console.log(this.overDueRecords);
            let A: number = this.overDueRecords[j].invcFinalTotal;
            console.log(A);
            this.totalOverdues += A;
            console.log(this.totalOverdues);
        }
        this.totalPaid = 0;
        for (let k = 0; k < this.paidRecords.length; k++) {
            console.log(this.paidRecords);
            let A: number = this.paidRecords[k].invcFinalTotal; 
            console.log(A);
            this.totalPaid += A;
            console.log(this.totalPaid);
        }

        console.log(this.totalSales);
    }


    onSelect(event) {
        console.log(event);
    }
    
   
}
